import React from 'react';
import FeesCalculator from '../../components/accounting/FeesCalculator/FeesCalculator';
import './FeesPage.css'; // Assuming you have or will create a CSS file for FeesPage

const FeesPage = () => {
  return (
    <div className="fees-page">
      {/* <h1 className="page-title">School Fees</h1> */}
      {/* Remove Header and Footer as they are now in DashboardLayout */}
      <div className="main-content">
          <FeesCalculator />
      </div>
    </div>
  );
};

export default FeesPage;